var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Layout, Dependencies } from "~/core/decorator";
import DataForm from "~/components/common/data-form.vue";
import DataBox from "~/components/common/data-box.vue";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import { AlipayInfoService } from "~/services/repair-service/alipayInfo.service";
import AddAlipayData from "~/components/data-repair/alipay-data/add-alipay-data.vue";
import EditAlipayData from "~/components/data-repair/alipay-data/edit-alipay-data.vue";
import DataImport from "~/components/data-repair/data-import.vue";
//@Auth(105)
var AlipayData = /** @class */ (function (_super) {
    __extends(AlipayData, _super);
    function AlipayData() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.improtType = "PAY_INFORMATION"; //支付宝信息
        _this.censusModel = {};
        _this.editModel = {};
        _this.dataSet = [];
        _this.kosekiModel = {
            id: "",
            name: "",
            idNo: "",
            bank: "",
            kosekiArea: "",
            koseki: "",
            applyTransferArea: "",
            applyTransferTime: "",
            serviceSpace: "",
            newAddress: "",
            usedName: "",
            remark: ""
        };
        _this.data = {};
        _this.loading = {
            state: false
        };
        _this.dialog = {
            detail: false,
            edit: false,
            import: false
        };
        return _this;
    }
    AlipayData.prototype.created = function () { };
    AlipayData.prototype.mounted = function () {
        this.refreshData();
    };
    /**
     * keep-alive生命周期钩子函数
     */
    AlipayData.prototype.activated = function () {
        // 加载数据
        this.refreshData();
    };
    /**
     * 查询支付宝资料
     */
    AlipayData.prototype.refreshData = function () {
        var _this = this;
        this.loading.state = true;
        this.alipayInfoService
            .search(this.kosekiModel, this.pageService, this.sortService, this.loading)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    //添加户籍弹窗
    AlipayData.prototype.addClick = function () {
        this.dialog.detail = true;
    };
    AlipayData.prototype.dataImpClick = function () {
        this.dialog.import = true;
    };
    /**
     * 删除支付宝资料
     */
    AlipayData.prototype.deleteKoseki = function (scope) {
        var _this = this;
        this.$confirm("您确定要删除吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        })
            .then(function () {
            _this.loading.state = true;
            _this.alipayInfoService
                .delete(scope.row, _this.loading)
                .subscribe(function (data) {
                _this.$message.success("操作成功");
                _this.refreshData();
            });
        }, function (err) {
            _this.$message.error(err.msg);
        })
            .catch(function () {
            _this.$message({
                type: "info",
                message: "已取消删除"
            });
        });
    };
    /**
     * 修改户籍弹框
     */
    AlipayData.prototype.editKoseki = function (scope) {
        this.editModel = scope.row;
        this.dialog.edit = true;
    };
    __decorate([
        Dependencies(PageService)
    ], AlipayData.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], AlipayData.prototype, "sortService", void 0);
    __decorate([
        Dependencies(AlipayInfoService)
    ], AlipayData.prototype, "alipayInfoService", void 0);
    AlipayData = __decorate([
        Layout("workspace"),
        Component({
            components: {
                DataForm: DataForm,
                DataBox: DataBox,
                AddAlipayData: AddAlipayData,
                EditAlipayData: EditAlipayData,
                DataImport: DataImport
            }
        })
    ], AlipayData);
    return AlipayData;
}(Vue));
export default AlipayData;
